/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Default_TitleInputs */

const en_image_export_default_title = /** @type {(inputs: Image_Export_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitles`)
};

const fr_image_export_default_title = /** @type {(inputs: Image_Export_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-titres`)
};

const de_image_export_default_title = /** @type {(inputs: Image_Export_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel`)
};

const it_image_export_default_title = /** @type {(inputs: Image_Export_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitoli`)
};

const ru_image_export_default_title = /** @type {(inputs: Image_Export_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Субтитры`)
};

const es_image_export_default_title = /** @type {(inputs: Image_Export_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtítulos`)
};

const zh_cn2_image_export_default_title = /** @type {(inputs: Image_Export_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕`)
};

const ja_image_export_default_title = /** @type {(inputs: Image_Export_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕`)
};

const hi_image_export_default_title = /** @type {(inputs: Image_Export_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक`)
};

const pt_pt2_image_export_default_title = /** @type {(inputs: Image_Export_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendas`)
};

/**
* | output |
* | --- |
* | "Subtitles" |
*
* @param {Image_Export_Default_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_default_title = /** @type {((inputs?: Image_Export_Default_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Default_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_default_title(inputs)
	if (locale === "de") return de_image_export_default_title(inputs)
	if (locale === "it") return it_image_export_default_title(inputs)
	if (locale === "ru") return ru_image_export_default_title(inputs)
	if (locale === "es") return es_image_export_default_title(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_default_title(inputs)
	if (locale === "ja") return ja_image_export_default_title(inputs)
	if (locale === "hi") return hi_image_export_default_title(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_default_title(inputs)
	return en_image_export_default_title(inputs)
});